import { ROUTE_BASE_URL } from "../../api/common"

const baseMenu = [
  {
    id: "main",
    label: "Main",
  },
  {
    id: "configure",
    label: "Configure",
  },
]

// Restricted items to show ONLY on home page and admin/event management pages
const restrictedIds = [1, 2, 3, 19, "configure"]

// Non-restricted items to show on all other pages
const nonRestrictedIds = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 16, 17, 18, 20, 21, 22]

// Full menu list (includes everything)
const allMenuItems = [
  // Main Section Items
  {
    id: 1,
    icon: "fa fa-home",
    label: "Dashboard",
    to: `${ROUTE_BASE_URL}/events-dashboard`,
  },
  {
    id: 2,
    icon: "icon-calendar",
    label: "All Events",
    to: `${ROUTE_BASE_URL}/event-management`,
  },
  {
    id: 3,
    icon: "fa fa-users",
    label: "Admin Team",
    to: `${ROUTE_BASE_URL}/admin-team`,
  },
  {
    id: 19,
    icon: "fa fa-gear",
    label: "Roles & Permissions",
    to: `${ROUTE_BASE_URL}/roles-and-permission`,
  },
  {
    id: 4,
    icon: "fa fa-home",
    label: "Overview",
    to: `${ROUTE_BASE_URL}/event-overview/${localStorage.getItem("eventId") || ""}`,
  },
  {
    id: 5,
    icon: "fa fa-users",
    label: "Event attendees",
    to: `${ROUTE_BASE_URL}/event-attentees`,
  },
  {
    id: 6,
    icon: "fa fa-dollar",
    label: "Event Order Payments",
    to: `${ROUTE_BASE_URL}/event-order-payments`,
  },
  {
    id: 18,
    icon: "fa fa-check",
    label: "Check-in",
    to: `${ROUTE_BASE_URL}/attendees-checkin`,
  },
  {
    id: 20,
    icon: "fa fa-file",
    label: "Reports",
    to: `${ROUTE_BASE_URL}/reports`,
  },

  // Configure Section Items
  {
    id: 7,
    icon: "icon-home",
    label: "Event Page",
    to: `${ROUTE_BASE_URL}/event-registration`,
  },
  {
    id: 8,
    icon: "fa fa-info-circle",
    label: "Event Info",
    to: `${ROUTE_BASE_URL}/event-registration-info`,
  },
  {
    id: 9,
    icon: "fa fa-ticket",
    label: "Event Tickets",
    to: `${ROUTE_BASE_URL}/event-tickets`,
  },
  {
    id: 10,
    icon: "fa fa-table",
    label: "Dynamic Forms",
    to: `${ROUTE_BASE_URL}/dynamic-forms`,
  },
  {
    id: 11,
    icon: "fa fa-money",
    label: "Coupons",
    to: `${ROUTE_BASE_URL}/coupons`,
  },
  {
    id: 12,
    icon: "icon-envelope",
    label: "Emails",
    to: `${ROUTE_BASE_URL}/event-emails`,
  },
  {
    id: 13,
    icon: "fa fa-plus-square",
    label: "Addons",
    to: `${ROUTE_BASE_URL}/event-addons`,
  },
  {
    id: 16,
    icon: "fa fa-gear",
    label: "Settings",
    to: `${ROUTE_BASE_URL}/settings`,
  },
  {
    id: 17,
    icon: "fa fa-credit-card",
    label: "Payment Settings",
    to: `${ROUTE_BASE_URL}/payment-settings`,
  },
  {
    id: 21,
    icon: "fa fa-id-card-o",
    label: "Badge",
    to: `${ROUTE_BASE_URL}/badge`,
  },
  {
    id: 22,
    icon: "fa fa-picture-o",
    label: "certificate",
    to: `${ROUTE_BASE_URL}/certificate-list`,
  }  
]

export { baseMenu, allMenuItems, restrictedIds, nonRestrictedIds }
